import React, { useEffect } from 'react';
import InputType from './ComponentsTpes/InputType';

const FireAlarmIn =  ({  fieldsData, componentSourceOptions ,
    selectedPorts, setSelectedPorts, savedData, setSavedData}) => {

    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                Fire_Alarm_in:{
                    ...prevData.Fire_Alarm_in,
                    [key]: value
                }
            }
        })
    }


    return (<InputType
        setSelectedPorts={setSelectedPorts}
        selectedPorts={selectedPorts}
        source={componentSourceOptions.inputsData}
        selectOptions={selectOptions}
        component_source={savedData.Fire_Alarm_in.component_source.value}
        condition={savedData.Fire_Alarm_in.condition}
        input={savedData.Fire_Alarm_in.input}
        name="Fire_Alarm_in"
        fieldsData={fieldsData}
    />)
}

export default FireAlarmIn;